import { render, staticRenderFns } from "./dutyListBatch.vue?vue&type=template&id=1c6da3bc&scoped=true&"
import script from "./dutyListBatch.vue?vue&type=script&lang=ts&"
export * from "./dutyListBatch.vue?vue&type=script&lang=ts&"
import style0 from "./dutyListBatch.vue?vue&type=style&index=0&id=1c6da3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6da3bc",
  null
  
)

export default component.exports